module.exports = __webpack_public_path__ + "media/images/pic/brodno/not_just_courses-acf397dae00593765402941683c6319c.png";